



































































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateSwitch from "./createswitch.vue";
import EditSwitch from "./editswitch.vue";
import CopySwitch from "./copyswitch.vue";
import TimingSetting from "./timingsetting.vue";
import AuthorizationSwitch from "./authorizationswitch.vue";
import Detail from "./switchdetail.vue";
import Moment from "moment-timezone";
import ControlDto from "@/store/entities/devices/switchs/controldto";
import ReplaceDeviceId from "@/views/basedatas/deviceTenant/replacedeviceId.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageMeterRequest extends PageRequest {
  keyword: string;
  areaId: number;
}

@Component({
  components: {
    CreateSwitch,
    EditSwitch,
    CopySwitch,
    TimingSetting,
    Detail,
    AuthorizationSwitch,
    ReplaceDeviceId,
  },
})
export default class Switchs extends AbpBase {
  //filters
  pagerequest: PageMeterRequest = new PageMeterRequest();
  columnlist: any[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  modelType: any[] = [];
  columnfalse: any[] = [];
  createModalShow: boolean = false; //新建
  editModalShow: boolean = false; //编辑
  copyModalShow: boolean = false; //复制
  timingSettingModalShow: boolean = false; //设置时间
  importModalShow: boolean = false; //导入数据
  detailModalShow: boolean = false; //明细数据
  autorizationModalShow: boolean = false; //授权窗口
  height: number = 300; //表格高度
  loadingdata: boolean = false; //按钮状态
  menuId: number = 0;
  showcolumn: boolean = false; //显示列选择窗口
  detailId: string = ""; //选择的明细Id
  switchId: any[] = []; //被选择Id
  switchNo: any[] = []; //被选择的设备编号
  collectorList: any[] = [];//采集器列表
  controlDto: ControlDto = new ControlDto(); //控制实体类
  splitnum: number = 0.15;
  deviceId: string = "";
  deviceModalShow: boolean = false; //更新表计平台Id

  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //采集器
  async getCollectorList() {
    await this.$store
      .dispatch("collector/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.collectorList.push(ele);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //更换平台Id
  async replacedeviceid(deviceId: string) {
    this.deviceId = deviceId;
    this.deviceModalShow = true;
  }
  //复制
  async copy() {
    this.copyModalShow = true;
  }
  //开
  async switchOpen() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose"),
      });
      return;
    }
    this.controlDto.switchId = [];
    val.forEach((ele) => {
      this.controlDto.switchId.push(ele.id);
    });
    this.controlDto.controlModl = 45;
    this.controlDto.controlRang = 0;
    this.controlDto.areaId = this.pagerequest.areaId;
    this.loadingdata = true;
    let res = await this.$store
      .dispatch({
        type: "switchs/switchcontrol",
        data: this.controlDto,
      })
      .catch((err) => {
        this.loadingdata = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.loadingdata = false;
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.loadingdata = false;
  }
  //授权设备
  async authorizationSwitch() {
    let val = (this.$refs.selection as any).getSelection();
    this.switchId = [];
    this.switchNo = [];
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Meter"),
      });
      return;
    }
    val.forEach((ele) => {
      this.switchId.push(ele.id);
      this.switchNo.push(ele.deviceNo);
    });
    this.autorizationModalShow = true;
  }
  //关
  async switchClose() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose"),
      });
      return;
    }
    this.controlDto.switchId = [];
    val.forEach((ele) => {
      this.controlDto.switchId.push(ele.id);
    });
    this.controlDto.controlModl = 46;
    this.controlDto.controlRang = 0;
    this.controlDto.areaId = this.pagerequest.areaId;
    this.loadingdata = true;
    let res = await this.$store
      .dispatch({
        type: "switchs/switchcontrol",
        data: this.controlDto,
      })
      .catch((err) => {
        this.loadingdata = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.loadingdata = false;
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.loadingdata = false;
  }
  //创建指令
  async switchCreateCommand() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose"),
      });
      return;
    }
    this.controlDto.switchId = [];
    val.forEach((ele) => {
      this.controlDto.switchId.push(ele.id);
    });
    this.controlDto.paramsId = [];
    this.controlDto.paramsId.push(79);
    this.controlDto.paramsId.push(45);
    this.controlDto.paramsId.push(46);
    this.controlDto.controlRang = 0;
    this.controlDto.areaId = this.pagerequest.areaId;
    this.loadingdata = true;
    let res = await this.$store
      .dispatch({
        type: "switchs/createcommand",
        data: this.controlDto,
      })
      .catch((err) => {
        this.loadingdata = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.loadingdata = false;
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.loadingdata = false;
  }
  //明细
  detail(id: string) {
    this.detailId = id;
    this.detailModalShow = true;
  }
  //获取菜单Id
  getmenu() {
    let menulist = JSON.parse(localStorage.getItem("userAuth"));
    let menu = menulist.filter((ele) => {
      return ele.value == "switchs";
    });
    if (menu.length > 0) {
      this.menuId = menu[0].id;
    }
    let se = this.columns.filter((ele) => {
      return ele.sortId == 0 || ele.sortId == 1 || ele.sortId == 49;
    });
    se.forEach((ele) => {
      this.columnlist.push(ele);
    });
  }
  //获取自定义字段
  async getuserfields() {
    let res = await this.$store.dispatch({
      type: "userfield/getuserfield",
      data: { menuId: this.menuId },
    });
    //把列加入显示列表
    this.columns.forEach((ele) => {
      if (ele.sortId != 0 && ele.sortId != 1 && ele.sortId != 49) {
        this.columnfalse.push({
          fieldName: ele.key,
          isShow: true,
          sortCode: ele.sortId,
          showTag: ele.title,
        });
      }
    });
    //如果设置了自定义列
    if (res.length > 0) {
      let restrue = res.filter((ele) => {
        return ele.isShow == true;
      });
      restrue.forEach((ele) => {
        let col = this.columns.filter((colum) => {
          return colum.key == ele.fieldName;
        });
        if (col.length > 0) {
          col[0].sortId = ele.sortCode;
          this.columnlist.push(col[0]);
        }
      });
      this.columnfalse.forEach((ele) => {
        let col = restrue.filter((colum) => {
          return colum.fieldName == ele.fieldName;
        });
        //console.log(col)
        if (col.length > 0) {
          ele.isShow = col[0].isShow;
        } else {
          ele.isShow = false;
        }
      });
    } else {
      this.columnlist = this.columns;
    }
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  //改变显示
  handleChange(event: any, val: any) {
    if (event) {
      //选中显示
      let showcol = this.columns.filter((col) => {
        return col.key === val;
      });
      if (showcol.length > 0) {
        let sh = this.columnfalse.filter((p) => {
          return p.fieldName == val;
        });
        if (sh.length > 0) {
          showcol[0].sortId = sh[0].sortCode;
        }
        this.columnlist.push(showcol[0]);
      }
    } else {
      //不显示
      this.columnlist = this.columnlist.filter((col) => {
        return col.key !== val;
      });
    }
    //排序
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  //改变排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.switchs.list;
  }
  get loading() {
    return this.$store.state.switchs.loading;
  }
  create() {
    this.createModalShow = true;
  }
  showcol() {
    this.showcolumn = true;
  }
  isActiveChange(val: number) {
    this.$store.commit("switchs/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("switchs/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("switchs/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("switchs/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "switchs/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.switchs.pageSize;
  }
  get totalCount() {
    return this.$store.state.switchs.totalCount;
  }
  get currentPage() {
    return this.$store.state.switchs.currentPage;
  }
  //列名
  columns = [
    {
      type: "index",
      width: 70,
      align: "center",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      type: "selection",
      width: 40,
      align: "left",
      fixed: "left",
      sortId: 1,
    },
    {
      sortable: true,
      title: this.L("DeviceNo"),
      key: "deviceNo",
      resizable: true,
      width: 130,
      fixed: "left",
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceNo,
            },
          },
          params.row.deviceNo
        );
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      sortable: true,
      resizable: true,
      sortId: 3,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      sortable: true,
      title: this.L("CollectorId"),
      key: "collectorId",
      width: 130,
      resizable: true,
      sortId: 7,
      render: (h: any, params: any) => {
        let id = params.row.collectorId;
        let info = this.collectorList.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].no : this.L("DirectLink"),
            },
          },
          info.length > 0 ? info[0].no : this.L("DirectLink")
        );
      },
    },
    {
      sortable: true,
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 130,
      resizable: true,
      sortId: 4,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      title: this.L("LineState"),
      key: "lineState",
      resizable: true,
      width: 110,
      sortId: 5,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lineState == true ? this.L("InLine") : this.L("OffLine")
        );
      },
    },
    {
      title: this.L("OnOffState"),
      key: "onOffState",
      resizable: true,
      width: 110,
      sortId: 6,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.onOffState == true ? this.L("Open") : this.L("Close")
        );
      },
    },
    {
      title: this.L("CSQ"),
      key: "csq",
      resizable: true,
      width: 90,
      sortId: 7,
    },
    {
      title: this.L("LastReportTime"),
      key: "lastReportTime",
      resizable: true,
      width: 160,
      sortId: 8,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReportTime == null
            ? ""
            : Moment(params.row.lastReportTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Voltage"),
      key: "voltage",
      resizable: true,
      width: 90,
      sortId: 7,
    },
    {
      title: this.L("IsWriteTime"),
      key: "isWriteTime",
      resizable: true,
      width: 130,
      sortable: true,
      sortId: 9,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isWriteTime == true ? this.L("Sented") : this.L("NoSent")
        );
      },
    },
    {
      title: this.L("RSRQ"),
      key: "rsrq",
      resizable: true,
      width: 90,
      sortId: 10,
    },
    {
      title: this.L("SNR"),
      key: "snr",
      resizable: true,
      width: 90,
      sortId: 11,
    },
    {
      title: this.L("RSRI"),
      key: "rsri",
      resizable: true,
      width: 90,
      sortId: 12,
    },
    {
      title: this.L("CoverLevel"),
      key: "converLevel",
      resizable: true,
      width: 90,
      sortId: 13,
    },
    {
      title: this.L("CellId"),
      key: "cellId",
      resizable: true,
      width: 90,
      sortId: 14,
    },
    {
      title: this.L("OnLineTime"),
      key: "onLineTime",
      resizable: true,
      sortable: true,
      width: 160,
      sortId: 15,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.onLineTime == null
            ? ""
            : Moment(params.row.onLineTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("OffLineTime"),
      key: "offLineTime",
      resizable: true,
      width: 160,
      sortId: 16,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.offLineTime == null
            ? ""
            : Moment(params.row.offLineTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Imei"),
      key: "imei",
      resizable: true,
      width: 140,
      sortId: 17,
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
      resizable: true,
      sortId: 18,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      resizable: true,
      sortId: 19,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      resizable: true,
      sortId: 20,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("IMSI"),
      key: "imsi",
      resizable: true,
      width: 130,
      sortId: 21,
    },
    {
      sortable: true,
      title: this.L("ModelInfo"),
      key: "modelId",
      resizable: true,
      width: 130,
      sortId: 22,
      render: (h: any, params: any) => {
        let id = params.row.modelId;
        let info = this.modelType.filter((p) => {
          return p.value == id;
        });
        return h("span", info.length > 0 ? info[0].label : this.L("Unknown"));
      },
    },
    {
      title: this.L("TransferType"),
      key: "transferType",
      width: 130,
      sortable: true,
      resizable: true,
      sortId: 23,
      render: (h: any, params: any) => {
        let id = params.row.transferType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("DeviceType"),
      key: "deviceTypeId",
      width: 130,
      sortable: true,
      resizable: true,
      sortId: 24,
      render: (h: any, params: any) => {
        let id = params.row.deviceTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].name : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].name : this.L("Unknown")
        );
      },
    },
    {
      sortable: true,
      title: this.L("ISP"),
      key: "isp",
      resizable: true,
      width: 130,
      sortId: 25,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("IsSec"),
      key: "isSec",
      resizable: true,
      width: 90,
      sortId: 26,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isSec == true ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("AesKey"),
      key: "aesKey",
      resizable: true,
      width: 130,
      sortId: 27,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.aesKey },
            },
            params.row.aesKey
          ),
        ]);
      },
    },
    {
      title: "AppId",
      key: "appId",
      resizable: true,
      width: 130,
      sortId: 28,
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
      resizable: true,
      sortId: 29,
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      width: 130,
      sortId: 30,
      resizable: true,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].name : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].name : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Tenants") + "Id",
      key: "aepTenantId",
      width: 130,
      sortId: 31,
      resizable: true,
    },
    {
      title: this.L("Product") + "Id",
      key: "productId",
      width: 130,
      resizable: true,
      sortId: 32,
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      resizable: true,
      sortId: 33,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.masterId },
            },
            params.row.masterId
          ),
        ]);
      },
    },
    {
      title: this.L("Manufacturer") + "Id",
      key: "manufacturerId",
      width: 130,
      resizable: true,
      sortId: 34,
    },
    {
      title: this.L("Manufacturer") + this.L("Name"),
      key: "manufacturerName",
      width: 130,
      resizable: true,
      sortId: 35,
    },
    {
      title: this.L("Device") + this.L("Model"),
      key: "deviceModel",
      width: 130,
      sortId: 36,
      resizable: true,
    },
    {
      title: this.L("Object"),
      key: "obj_Id",
      width: 130,
      resizable: true,
      sortId: 37,
    },
    {
      title: this.L("Inst"),
      key: "obj_Inst_id",
      width: 130,
      sortId: 38,
      resizable: true,
    },
    {
      title: this.L("Resource"),
      key: "res_Id",
      width: 130,
      resizable: true,
      sortId: 39,
    },
    {
      sortable: true,
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      resizable: true,
      sortId: 40,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("Platform") + "Id",
      key: "ispDeviceId",
      width: 130,
      resizable: true,
      sortId: 41,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.ispDeviceId },
            },
            params.row.ispDeviceId
          ),
        ]);
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
      resizable: true,
      sortId: 42,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      sortId: 43,
      resizable: true,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.description },
            },
            params.row.description
          ),
        ]);
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 280,
      fixed: "right",
      sortId: 44,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('switchsDel');
        let edit = this.checkButtonAuth('switchsEdit');
        let copy = this.checkButtonAuth('switchCopy');
        let record = this.checkButtonAuth('switchRecord');//上报记录
        let replaceId = this.checkButtonAuth('switchReplaceId');//更换平台Id
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("switchs/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          copy ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("switchs/edit", params.row);
                  this.copy();
                },
              },
            },
            this.L("Copy")
          ) : '',
          record ? h(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.detail(params.row.id);
                },
              },
            },
            this.L("Record")
          ) : '',
          replaceId ? h(
            "Button",
            {
              props: {
                type: "info",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  await this.replacedeviceid(params.row.id);
                },
              },
            },
            this.L("ReplacePlateFormId")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "switchs/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  //模型
  async getmodelType() {
    await this.$store
      .dispatch("switchmodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.modelType.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async created() {
    this.getmenu();
    await this.getuserfields();
    await this.getCollectorList();
    this.getAreaTree();
    this.getItemDetail();
    this.getpage();
    this.getmodelType();
  }
  //导出数据
  async exportData(type: any) {
    //console.log(type);
    let fileName = Moment().format("x");
    if (type === 'exportCurrentPage') {//当前页数据
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, columns: this.columnlist });
    } else {
      this.pagerequest.skipCount = 0;
      this.pagerequest.maxResultCount = 10000;
      await this.$store.dispatch({
        type: "meter/getAll",
        data: this.pagerequest,
      });
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, data: this.$store.state.meter.list, columns: this.columnlist });
    }
  }
  data() {
    return {
      transferType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  //明细
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));

    if (detaillist.length > 0) {
      let trans = detaillist.filter((p) => {
        return p.itemId == 13;
      });
      trans.forEach((ele) => {
        this.$data.transferType.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
  }
  //定时设置
  timingSetting() {
    let val = (this.$refs.selection as any).getSelection();
    this.switchId = [];
    this.switchNo = [];
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Meter"),
      });
      return;
    }
    val.forEach((ele) => {
      this.switchId.push(ele.id);
      this.switchNo.push(ele.deviceNo);
    });
    this.timingSettingModalShow = true;
  }
  //下发定时设置
  sendTiming() { }
  //取消注册
  async cancelregister() {
    let val = (this.$refs.selection as any).getSelection();
    let meterId: any[] = [];
    if (val.length > 0) {
      val.forEach((ele) => {
        meterId.push(ele.id);
      });
    }
    if (meterId.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Customer"),
      });
    }
    this.loadingdata = true;
    let res = await this.$store
      .dispatch({
        type: "meter/cancelRegisterMeter",
        data: meterId,
      })
      .catch((err) => {
        this.loadingdata = false;
      });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.loadingdata = false;
    this.getpage();
  }
  //注册
  async register() {
    let val = (this.$refs.selection as any).getSelection();
    let meterId: any[] = [];
    let checkVal: number = 0;
    if (val.length > 0) {
      val.forEach((ele) => {
        if (ele.transferType != 34) {
          checkVal = 1;
          return;
        }
        meterId.push(ele.id);
      });
    }
    if (checkVal == 1) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("NoLink"),
      });
      return;
    }
    if (meterId.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Meter"),
      });
      return;
    }
    this.loadingdata = true;
    let res = await this.$store
      .dispatch({
        type: "meter/registerMeter",
        data: meterId,
      })
      .catch((err) => {
        this.loadingdata = false;
      });
    //console.log(res)
    this.loadingdata = false;
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.getpage();
  }
  //导入数据
  ImportData() {
    this.importModalShow = true;
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 380;
    } else {
      this.height = window.innerHeight - 420;
    }
  }
}
